import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Theme } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import ImportIcon from '@material-ui/icons/Publish';
import { observer } from 'mobx-react';
import React from 'react';
import { transl } from '../../main/transl';
import { IFeedback } from '../../services/Communicator';

const useStyles = makeStyles((theme: Theme) => ({
	importFeedbackDialog: {
		'& .MuiPaper-root': {
			minWidth: '40%',
		},
	},
	list: {
		overflowY: 'auto',
		padding: '10px 40px',
	},
	INFO: {
	},
	WARNING: {
		color: '#C20',
	},
	ERROR: {
		color: '#F00',
		fontWeight: 'bold',
	},
}));

interface IImportFeedbackDialogProps {
	feedbacks: Array<IFeedback>
	execute?: (e?: any) => void
	cancel: (e?: any) => void
}

export const ImportFeedbackDialog = observer(function(props: IImportFeedbackDialogProps) {
	const classes = useStyles();
	const {feedbacks, execute, cancel} = props;
	return <Dialog open={!!feedbacks.length} onClose={close} className={classes.importFeedbackDialog}>
		<DialogTitle>{transl(execute ? 'importConfirmation' : 'importError')}</DialogTitle>
		<DialogContent>
			<ul className={classes.list}>
				{feedbacks.map((p, i) => <li key={i} className={classes[p.level]}>{p.text}</li>)}
			</ul>
		</DialogContent>
		<DialogActions>
			<Button startIcon={<CancelIcon/>} onClick={cancel}>{transl('cancel')}</Button>
			{!execute ? null : <Button color="primary" startIcon={<ImportIcon/>} onClick={execute}>{transl('execute')}</Button>}
		</DialogActions>
	</Dialog>;
});
